import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { NgxMaskPipe } from 'ngx-mask';
import { ClientList } from '../../../core/models/client.model';

@Component({
  selector: 'app-client-card',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, NgxMaskPipe],
  templateUrl: './client-card.component.html',
  styleUrl: './client-card.component.scss',
})
export class ClientCardComponent {
  @Input({ required: true }) client!: ClientList;
}
